export default function () {
  if (typeof Landbot !== 'undefined') {
    import(
      /* webpackChunkName: "pet-name-generator-module" */ '../pet-name-generator'
    ).then((module) => {
      const PetNameGenerator = module.default
      PetNameGenerator()
    })

    import(
      /* webpackChunkName: "pet-q-check-popup-module" */ '../pet-q-check'
    ).then((module) => {
      const PetQCheckPopup = module.default
      PetQCheckPopup()
    })

    import(/* webpackChunkName: "recalls-popup" */ '../recalls').then(
      (module) => {
        const RecallsPopup = module.default
        RecallsPopup()
      }
    )
  }
}
